import { useRef, useState } from "react";

const MIN_WIDTH = 360;
const STORAGE_KEY = "aria_panel_width";

// Drawer width with drag-to-resize; crossing 50vw hands off to fullscreen via onPopOut.
export const useAriaPanel = ({ onPopOut }) => {
  const [panelWidth, setPanelWidth] = useState(() => {
    const w = parseInt(localStorage.getItem(STORAGE_KEY), 10);
    return Number.isFinite(w) ? Math.max(MIN_WIDTH, w) : 430;
  });
  const [dragging, setDragging] = useState(false);
  const widthRef = useRef(panelWidth);
  widthRef.current = panelWidth;

  const startResize = (e) => {
    e.preventDefault();
    setDragging(true);
    const cleanup = () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
    };
    const onMove = (ev) => {
      const w = Math.max(MIN_WIDTH, window.innerWidth - ev.clientX);
      if (w >= window.innerWidth * 0.5) {
        cleanup();
        setDragging(false);
        onPopOut();
        return;
      }
      setPanelWidth(w);
    };
    const onUp = () => {
      cleanup();
      setDragging(false);
      localStorage.setItem(STORAGE_KEY, String(widthRef.current));
    };
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  };

  return { panelWidth, dragging, startResize };
};
